/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElDatePicker as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import gameListHooks from '@/views/gameListHooks';
import { apiInternalReplaceLogs } from '@/api/customerInternal';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'repairLog',
  setup(__props) {
    const filter = ref({
      gid: '',
      orderTime: '',
      operator: '',
      loginName: '',
      cmgeOrderNum: ''
    });
    const columns = [{
      label: '操作人',
      prop: 'operator'
    }, {
      label: '操作时间',
      prop: 'operTime',
      slot: 'operTime'
    }, {
      label: '登录名',
      prop: 'loginName'
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum'
    }, {
      label: '成交金额',
      prop: 'amount'
    }, {
      label: '下单时间',
      prop: 'submitTime'
    }];
    const {
      gameList,
      getGameList
    } = gameListHooks();
    const getTableData = () => {
      const {
        gid,
        orderTime,
        operator,
        loginName,
        cmgeOrderNum
      } = filter.value;
      const params = {
        gid,
        pageSize: 10,
        pageNum: current.value,
        cmgeOrderNum: cmgeOrderNum || undefined,
        loginName: loginName || undefined,
        operator: operator || undefined,
        startDate: orderTime && orderTime.length ? dayjs(orderTime[0]).format('YYYY-MM-DD') : undefined,
        endDate: orderTime && orderTime.length ? dayjs(orderTime[1]).format('YYYY-MM-DD') : undefined
      };
      tableLoading.value = true;
      apiInternalReplaceLogs(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          total.value = res.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    onMounted(() => {
      getTableData();
      getGameList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_date_picker = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "repairLog"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "选择游戏"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(filter).gid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).gid = $event),
              placeholder: "搜索游戏",
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.Id,
                  value: item.Id,
                  label: item.Name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下单时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(filter).orderTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).orderTime = $event),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "操作人"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(filter).operator,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).operator = $event),
              placeholder: "请输入操作人"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "登录名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(filter).loginName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(filter).loginName = $event),
              placeholder: "请输入登录名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "平台订单号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(filter).cmgeOrderNum,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(filter).cmgeOrderNum = $event),
              placeholder: "请输入平台订单号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: getTableData
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          operTime: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.operTime)), 1)]),
          _: 1
        }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      });
    };
  }
});